import { render, staticRenderFns } from "./proProduct.vue?vue&type=template&id=64282a81&scoped=true&"
import script from "./proProduct.vue?vue&type=script&lang=ts&"
export * from "./proProduct.vue?vue&type=script&lang=ts&"
import style0 from "./proProduct.vue?vue&type=style&index=0&id=64282a81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64282a81",
  null
  
)

export default component.exports